import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  label: {
    marginRight: '0.5rem',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    userSelect: 'none',
    maxWidth: '100px'
  },

  chip: {
    margin: '0 0.5rem 0.25rem 0',
    alignContent: 'center',
    padding: '0.25rem 0.5rem',
    backgroundColor: '#F1F1F1',
    color: 'grey',
    borderRadius: '0.75rem',
    border: '0.0625rem solid white',
    display: 'flex',
    alignItems: 'center'
  }
}))

export default useStyles
